import(/* webpackMode: "eager" */ "/app/apps-node/webapp/src/app/error.tsx");
